import { render, staticRenderFns } from "./YoutubePopupLink.vue?vue&type=template&id=8c084cee&scoped=true&"
import script from "./YoutubePopupLink.vue?vue&type=script&lang=ts&"
export * from "./YoutubePopupLink.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubePopupLink.vue?vue&type=style&index=0&id=8c084cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c084cee",
  null
  
)

export default component.exports